import React from 'react';
export function HowQShieldWorksSection() {
  const reportingStats = [{
    number: '73%',
    label: 'Sleep improvement within 7 days'
  }, {
    number: '68%',
    label: 'Reduction in brain fog'
  }, {
    number: '61%',
    label: 'Improved mood/reduced anxiety'
  }, {
    number: '54%',
    label: 'Fewer nighttime wakings'
  }];
  return <section id="how-it-works" className="w-full py-8 md:py-12 lg:py-16 px-4 md:px-6 border-t-2" style={{
    background: 'linear-gradient(135deg, #F0F7FF 0%, #FFFFFF 100%)',
    borderColor: '#2D9B6E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-60">
      <div className="max-w-5xl mx-auto" data-id="element-61">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-3 text-center" style={{
        color: '#1B4F9E'
      }} data-id="element-62">
          HOW QSHIELD WORKS
        </h2>
        <p className="text-[16px] md:text-[18px] text-center mb-10" style={{
        color: '#2D9B6E',
        fontStyle: 'italic'
      }} data-id="element-63">
          And Why It Actually Reduces Measured Radiation
        </p>

        {/* Product Hero Image */}
        <div className="mb-10 -mx-4 md:-mx-6" data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/8LoU63XzAjFyuebMUpyG7g/unnamed_(7).jpg" alt="QShield EMF sticker on iPhone with EMF meter showing Before: 250 mV/m and After: 68 mV/m" className="w-full rounded-lg shadow-xl" style={{
          boxShadow: '0px 12px 32px rgba(27, 79, 158, 0.15)'
        }} data-id="element-65" />
        </div>

        {/* Two Column Explanation */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-66">
          {/* Left Column */}
          <div data-id="element-67">
            <h3 className="text-[24px] font-semibold mb-4" style={{
            color: '#1B4F9E'
          }} data-id="element-68">
              The Mechanism (Simple)
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: '#2C3E50',
            lineHeight: '1.7'
          }} data-id="element-69">
              QShield stickers use{' '}
              <strong data-id="element-70">advanced nano-material composition</strong> that absorbs{' '}
              <strong data-id="element-71">electromagnetic radiation</strong> and converts it to
              negligible heat dissipation. The nano-materials are applied in{' '}
              <strong data-id="element-72">ultra-thin adhesive layers</strong> that don't interfere
              with device function,
              <strong data-id="element-73"> wireless charging</strong>, or{' '}
              <strong data-id="element-74">Bluetooth connectivity</strong>.
            </p>
          </div>

          {/* Right Column */}
          <div className="lg:border-l-2 lg:pl-10" style={{
          borderColor: '#2D9B6E'
        }} data-id="element-75">
            <h3 className="text-[24px] font-semibold mb-4" style={{
            color: '#1B4F9E'
          }} data-id="element-76">
              Translated to Plain English
            </h3>
            <p className="text-base leading-relaxed" style={{
            color: '#2C3E50',
            lineHeight: '1.7'
          }} data-id="element-77">
              The stickers <strong data-id="element-78">absorb the EMF radiation</strong> coming from
              your phone, like a sponge absorbs water. The absorbed energy
              becomes a <strong data-id="element-79">tiny amount of heat that dissipates</strong>—so
              small you'll never notice it. And because the stickers are thin,
              they <strong data-id="element-80">don't block the signals</strong> your phone needs to
              work.
            </p>
            <div className="mt-6" data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/3bEgzKDXHiMpeqPRKywXvx/unnamed_(5).jpg" alt="Protection from ALL devices - QShield stickers work on tablets, phones, laptops, routers, and smart devices" className="w-full rounded-lg shadow-lg" data-id="element-82" />
            </div>
          </div>
        </div>

        {/* Measurement Results Box */}

        {/* Reporting Results Grid */}
        <div className="mt-6 p-6 rounded-md grid grid-cols-2 md:grid-cols-4 gap-4" style={{
        backgroundColor: '#267A52'
      }} data-id="element-83">
          {reportingStats.map((stat, index) => <div key={index} className="text-center text-white" data-id="element-84">
              <div className="text-2xl md:text-3xl font-bold" data-id="element-85">
                {stat.number}
              </div>
              <div className="text-xs mt-1" style={{
            color: '#E8F5F0'
          }} data-id="element-86">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* All Devices Image */}
        <div className="mt-8 -mx-4 md:-mx-6" data-id="element-87"></div>
      </div>
    </section>;
}